export default "__VITE_ASSET__LI3FGw3H__"